import { createContext } from 'react';

export interface ControlGesture { begin: () => void; end: () => void }
export const ControlGestureContext = createContext<ControlGesture>({ begin() {}, end() {} });
